export default "__VITE_ASSET__a206e8c9__"